import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "src/app/services/global.service";
import { BsrmhttpService } from "src/app/services/bsrmhttp.service";
import { DxDataGridComponent } from "devextreme-angular";

@Component({
  selector: "app-changepassword",
  templateUrl: "./changepassword.component.html",
  styleUrls: ["./changepassword.component.css"],
})
export class ChangepasswordComponent implements OnInit {
  data: any = {};
  successMessage: string = "";
  errorMessage: string = "";
  strongPassword = new RegExp(
    "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
  );

  isMessageVisible = false;
  constructor(
    private globalService: GlobalService,
    private http: BsrmhttpService,
    private router: Router
  ) {}

  clearData() {
    this.successMessage = "";
    this.errorMessage = "";
    this.isMessageVisible = false;
    this.data = {};
  }
  ngOnInit() {
    this.clearData();
  }

  Submit() {
    this.successMessage = "";
    this.errorMessage = "";

    this.globalService.showProgressbar();
    this.http.post("ChangePassword", this.data).subscribe(
      (d) => {
        this.globalService.hideProgressbar();
        var obj = JSON.parse(JSON.stringify(d));

        if (obj.error) {
          this.errorMessage = obj.message;
        } else {
          this.clearData();
          this.successMessage = obj.message;
          // this.isMessageVisible = true;

          if (confirm(obj.message)) {
            this.router.navigate(["login"]);
          } else {
            this.router.navigate(["login"]);
          }
        }
      },
      (e) => {
        this.globalService.hideProgressbar();
        this.errorMessage = "Unable to Change Password";
      }
    );
  }

  closePopup() {
    this.isMessageVisible = false;
  }

  resetPassword(e) {
    this.successMessage = "";
    this.errorMessage = "";

    if (this.data.OldPassword && this.data.OldPassword.length > 0) {
      if (this.data.NewPassword && this.data.NewPassword.length > 0) {
        if (!(this.data.NewPassword == this.data.OldPassword)) {
          if (
            this.data.ConfirmPassword &&
            this.data.ConfirmPassword.length > 0
          ) {
            if (this.data.NewPassword == this.data.ConfirmPassword) {
              this.Submit();
            } else {
              this.errorMessage =
                "New Password and Confirm Password not matched.";
            }
          } else {
            this.errorMessage = "Please enter confirm password and try again.";
          }
        } else {
          this.errorMessage =
            "Old Password and new password should not be the same";
        }
      } else {
        this.errorMessage = "Please enter new password and try again.";
      }
    } else {
      this.errorMessage = "Please enter Old Password and try again.";
    }
  }

  canChangePassword = false;
  newPasswordErrorMessage: string = "";
  confirmPasswordErrorMessage: string = "";
  checkPasswordMismatched() {
    this.canChangePassword = false;
    console.log(this.data);

    if (this.data.OldPassword && this.data.OldPassword.length > 0) {
      if (
        this.data.NewPassword &&
        this.data.NewPassword.length >= 8 &&
        this.data.ConfirmPassword &&
        this.data.ConfirmPassword.length >= 8 &&
        this.data.NewPassword == this.data.ConfirmPassword
      ) {
        this.canChangePassword = true;
      } else if (
        this.data.NewPassword &&
        this.data.NewPassword.length >= 8 &&
        this.data.ConfirmPassword &&
        this.data.ConfirmPassword.length >= 8 &&
        this.data.NewPassword != this.data.ConfirmPassword
      ) {
        this.confirmPasswordErrorMessage =
          "Password and Confirm Password not matched.";
      }
    }
  }
  newPasswordChanged() {
    this.newPasswordErrorMessage = this.checkPassword(this.data.NewPassword);
    if (this.newPasswordErrorMessage.length <= 0) {
      this.checkPasswordMismatched();
    }
  }
  confirmPasswordChanged() {
    this.confirmPasswordErrorMessage = this.checkPassword(
      this.data.ConfirmPassword
    );
    console.log(this.confirmPasswordErrorMessage);
    if (this.confirmPasswordErrorMessage.length <= 0) {
      console.log("insert into confirm check.");
      this.checkPasswordMismatched();
    }
  }

  checkPassword(val: string) {
    if (val && val.trim().length < 8) {
      return "Password should contain at least 8 alphanumeric character.";
    } else {
      var isNumberExist: boolean = false;
      var isCharExist: boolean = false;

      if (!this.strongPassword.test(val)) {
        return "Password Should have to at lease a uppercase, lowercase, digit or #$!%*?& and make sure the length is min 8 in length  ";
      } else {
        return "";
      }
    }
  }

  // checkPassword(val: string): string {
  //   if (val.trim().length < 8) {
  //     return "Password should contain at least 8 alphanumeric character.";
  //   } else {
  //     var isNumberExist: boolean = false;
  //     var isCharExist: boolean = false;

  //     var zeroCharCode: number = "0".charCodeAt(0);
  //     var nineCharCode: number = "9".charCodeAt(0);

  //     for (let i = 0; i < val.length; i++) {
  //       var charCode = val.charCodeAt(i);
  //       if (charCode >= zeroCharCode && charCode <= nineCharCode) {
  //         isNumberExist = true;
  //       } else {
  //         isCharExist = true;
  //       }
  //     }
  //     if (!isNumberExist) {
  //       return "Password should contain at least 1 character between 0 to 9.";
  //     } else if (!isCharExist) {
  //       return "Password should contain at least 1 alphabetic character.";
  //     } else {
  //       return "";
  //     }
  //   }
  // }
}
